/**
 * consentMode v 0.1
 */
function consentMode () {
  const cookieName = 'consent-mode'
  const cookieDays = 30
  const mainContainer = document.querySelector('.cookie-terms-alert-box')
  const acceptAllBtns = mainContainer.querySelectorAll('.cookie-terms-alert-box-btn-accept-all')
  const rejectAllBtns = mainContainer.querySelectorAll('.cookie-terms-alert-box-btn-reject-all')
  const acceptSomeBtn = mainContainer.querySelector('.cookie-terms-alert-box-btn-accept-some')
  const savedBadges = mainContainer.querySelectorAll('.cookie-terms-alert-box-saved-label')

  const inputs = {
    storage: mainContainer.querySelector('#ad_storage'),
    userdata: mainContainer.querySelector('#ad_user_data'),
    personalization: mainContainer.querySelector('#ad_personalization'),
    analyticsstorage: mainContainer.querySelector('#analytics_storage'),
  }

  function checkActivated () {
    if (localStorage.getItem('consentMode') !== null) {
      let activeFromStorage = JSON.parse(localStorage.getItem('consentMode'))
      Object.keys(activeFromStorage).forEach(key => {
        document.getElementById(key).checked = activeFromStorage[key] === 'granted'
      })
    }
  }

  function savedInfoBadge () {
    savedBadges.forEach((badge, index) => {
      badge.classList.add('cookie-terms-alert-box-active')

      setTimeout(function () {
        badge.classList.remove('cookie-terms-alert-box-active')
      }, 1000)
    })
  }

  function showSettingsListener () {
    const consentView1 = mainContainer.querySelector(`.cookie-terms-alert-box-cnt[data-step="1"]`)
    const consentView2 = mainContainer.querySelector(`.cookie-terms-alert-box-cnt[data-step="2"]`)
    const nextViewBtn = mainContainer.querySelector(`.cookie-terms-alert-box-consentNextView`)
    const prevViewBtn = mainContainer.querySelector(`.cookie-terms-alert-box-consentPrevView`)

    nextViewBtn.addEventListener('click', () => {
      consentView1.classList.remove('cookie-terms-alert-box-active')
      consentView2.classList.add('cookie-terms-alert-box-active')
    })

    prevViewBtn.addEventListener('click', () => {
      consentView2.classList.remove('cookie-terms-alert-box-active')
      consentView1.classList.add('cookie-terms-alert-box-active')
    })

  }

  function inputsListener () {
    const allCheckboxes = mainContainer.querySelectorAll('input[type="checkbox"]')
    allCheckboxes.forEach((checkbox, index) => {
      checkbox.addEventListener('change', () => {
        acceptSomeBtn.style.display = 'block'
      })
    })
  }

  function hideMainContainer () {
    mainContainer.classList.add('cookie-terms-alert-box-hidden-ver')
  }

  function save () {
    checkActivated()
    setCookie(cookieName, true, cookieDays)

    setTimeout(() => {
      hideMainContainer()
    }, 1200)

  }

  function setConsent (consent) {
    const consentMode = {
      'ad_storage': consent.storage ? 'granted' : 'denied',
      'ad_user_data': consent.userdata ? 'granted' : 'denied',
      'ad_personalization': consent.personalization ? 'granted' : 'denied',
      'analytics_storage': consent.analyticsstorage ? 'granted' : 'denied',
    }
    gtag('consent', 'update', consentMode)
    localStorage.setItem('consentMode', JSON.stringify(consentMode))

    savedInfoBadge()
  }

  /** cookies **/
  function getCookie (name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
    return v ? v[2] : null
  }

  function setCookie (name, value, days) {
    var d = new Date
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days)
    document.cookie = name + '=' + value + ';path=/;expires=' + d.toGMTString()
  }

  function deleteCookie (name) { setCookie(name, '', -1) }

  /** end cookies **/

  function init () {
    mainContainer.classList.add('cookie-terms-alert-box-active')

    checkActivated()
    showSettingsListener()
    inputsListener()

    acceptSomeBtn.addEventListener('click', function () {
      setConsent({
        storage: inputs.storage.checked,
        userdata: inputs.userdata.checked,
        personalization: inputs.personalization.checked,
        analyticsstorage: inputs.analyticsstorage.checked,
      })
      acceptSomeBtn.style.display = 'none'
      save()
    })

    acceptAllBtns.forEach((acceptAllBtn, index) => {
      acceptAllBtn.addEventListener('click', function () {
        setConsent({
          storage: true,
          userdata: true,
          personalization: true,
          analyticsstorage: true
        })
        save()
      })
    })

    rejectAllBtns.forEach((rejectAllBtn, index) => {
      rejectAllBtn.addEventListener('click', function () {
        setConsent({
          storage: false,
          userdata: false,
          personalization: false,
          analyticsstorage: false
        })
        save()
      })
    })
  }

  function start () {
    const cookieValue = getCookie(cookieName)

    if (cookieValue === null) {
      init()
    }

  }

  start()
}

export { consentMode }
